import { useMutation, useQueryClient } from "@tanstack/react-query";
import { axiosInstance } from "@/helpers/axios";
import type { ApiResponse } from "@/helpers/axios";

export const useDeleteDeviceMutation = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      const res = await axiosInstance.delete<ApiResponse<null>>(`/v2/devices/${id}`);
      if (!res.data.success) throw new Error(res.data.message ?? "Failed");
    },
    onSuccess: (_data, id) => {
      qc.invalidateQueries({ queryKey: ["devices"] });
      qc.removeQueries({ queryKey: ["device", id] });
    },
  });
};
